import ReactDOM from "react-dom/client";

import App from "~/components/features/App";
import {classPrefix, errorLog} from "~/lib";
import Wrapper from "~/components/templates/Wrapper";
import Loader from "~/components/common/Loader";
import {createTransform} from "redux-persist";
import {AccountInitialState} from "~/reducers/account.types";

(function (w, d, dlName, id) {
    if (dlName && id) {
        w[dlName] = w[dlName] || [];
        w[dlName].push({"gtm.start": new Date().getTime(), event: "gtm.js"});
        const f = d.getElementsByTagName("script")[0],
            j = d.createElement("script"),
            dl = dlName !== "dataLayer" ? "&l=" + dlName : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + id + dl;
        if (f.parentNode) {
            f.parentNode.insertBefore(j, f);
        }
    }
})(window, document, VITE__GTM_DL_NAME, VITE__GTM_ID);

const rootID = classPrefix("root");
const rootElement = document.getElementById(rootID);
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);

    if (VITE__ROOT_FONT_SIZE__) {
        document.documentElement.style.setProperty("--font-size-default", VITE__ROOT_FONT_SIZE__ + "px");
    }

    root.render(<App
        RouteComponent={Wrapper}
        persist={true}
        persistConfig={{
            whitelist: ["account"],
            transforms: [createTransform<AccountInitialState, any>(
                // transform state on its way to being serialized and persisted.
                (inboundState, key) => {
                    return key === "account" ? {
                        ...inboundState,
                        state: undefined
                    } : inboundState;
                },
                // transform state being rehydrated
                (outboundState, key) => {
                    return key === "account" ? {
                        ...outboundState,
                        state: undefined
                    } : outboundState;
                },
                // define which reducers this transform gets called for.
                { whitelist: ["account"] }
            )],
        }}
        persistLoading={<Loader size="large" type="text" loadingText="loading state" position="fixed"/>}
    />);
} else {
    errorLog(`Root element with id #${rootID} is missing`);
}
